/**
 * Created by mqamhieh on 6/14/18.
 */
(function (routes) {

    routes["/activated"] = {
        "clearPrevState": true,
        "name": "registration.activated",
        "showGlobalSearch": false,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "onEnter": ['userActivationService', function (userActivationService) {

            userActivationService.handleUserActivation();

        }]
    };

    routes["email-activation?code"] = {
        "clearPrevState": true,
        "name": "homepage.email-activation",
        "showGlobalSearch": false,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "onEnter": ['userActivationService', function (userActivationService) {

            userActivationService.handleUserEmailActivation();

        }]
    };

})(publicConfiguration['routes']);